import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);

    // ChunkLoadError means stale cached HTML referencing old JS chunks.
    // Auto-reload once to fetch the latest build.
    if (
      error?.name === 'ChunkLoadError' &&
      !window.__chunkReloadAttempted
    ) {
      window.__chunkReloadAttempted = true;
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: 24,
          margin: 16,
          background: 'var(--danger-bg, #fef2f2)',
          color: 'var(--danger, #dc2626)',
          border: '1px solid var(--danger-border, #fecaca)',
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Something went wrong.</h2>
          <p style={{ fontSize: 14, opacity: 0.8, marginBottom: 16 }}>{this.state.error?.toString()}</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '8px 16px',
              background: 'var(--danger, #dc2626)',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
